export default __webpack_public_path__ + "static/media/O-107.e0b01f97.png";